export default function accordion({ variables, }) {
    return {
        MuiAccordion: {
            defaultProps: {
                elevation: 0,
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    border: `1px solid ${variables.border_subtle}`,
                    backgroundColor: variables.surface,
                    backgroundImage: "none",
                    boxShadow: "none",
                    "&:not(:last-child)": {
                        borderBottom: 0,
                    },
                    "&::before": {
                        display: "none",
                    },
                    "&.Mui-expanded": {
                        margin: 0,
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    minHeight: variables.component_height_large,
                    padding: `0 ${variables.spacing_04}`,
                    fontSize: variables.type_body_font_size,
                    fontWeight: variables.font_weight_medium,
                    "&.Mui-expanded": {
                        minHeight: variables.component_height_large,
                    },
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                },
                content: {
                    margin: `${variables.spacing_03} 0`,
                    "&.Mui-expanded": {
                        margin: `${variables.spacing_03} 0`,
                    },
                },
                expandIconWrapper: {
                    color: variables.text_medium,
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: variables.spacing_04,
                    borderTop: `1px solid ${variables.border_subtle}`,
                    fontSize: variables.type_body_sm_font_size,
                },
            },
        },
        MuiAccordionActions: {
            styleOverrides: {
                root: {
                    padding: `${variables.spacing_03} ${variables.spacing_04}`,
                },
            },
        },
    };
}
//# sourceMappingURL=accordion.js.map